import Image, {type ImageProps} from 'next/image';
import {type FC, memo, type PropsWithChildren, type ReactElement} from 'react';

interface AppImageProps {
  src?: ImageProps['src'];
  size?: 'small' | 'default' | 'large';
}

const AppImage: FC<PropsWithChildren<AppImageProps>> = memo(({src, size = 'default'}): ReactElement | null => {
  return (
    <div
      className={`relative shrink-0
            ${size === 'large' ? 'h-[494px] w-[244px]' : 'h-[428px] w-[211px]'}
            ${size === 'small' ? 'lg:h-[494px] lg:w-[244px]' : 'lg:h-[644px] lg:w-[318px]'}
        `}
    >
      <div
        className={`absolute inset-0 
                ${size === 'large' ? 'h-[584px] w-[379px]' : 'h-[312px] w-[203px]'} 
                ${size === 'small' ? 'lg:h-[584px] lg:w-[379px]' : 'lg:h-[783px] lg:w-[488px]'}
            `}
      >
        <Image
          src="/images/phone-shadow.png"
          alt="Phone shadow image"
          draggable={false}
          fill
          className="object-contain"
          sizes={
            size === 'large'
              ? '(max-width: 1024px) 379px, 488px'
              : size === 'small'
                ? '(max-width: 1024px) 203px, 379px'
                : '(max-width: 1024px) 203px, 488px'
          }
        />
      </div>

      <Image
        src="/images/phone.png"
        alt="Phone image"
        fill
        className="object-contain"
        sizes={
          size === 'large'
            ? '(max-width: 1024px) 244px, 318px'
            : size === 'small'
              ? '(max-width: 1024px) 130px, 244px'
              : '(max-width: 1024px) 130px, 318px'
        }
      />

      {src && typeof src === 'string' && src.trim() !== '' && (
        <div className="absolute inset-[7px] lg:inset-[14px]">
          <Image
            src={src}
            alt="Phone content"
            fill
            className="rounded-2xl lg:rounded-3xl object-contain"
            sizes={
              size === 'large'
                ? '(max-width: 1024px) 230px, 290px'
                : size === 'small'
                  ? '(max-width: 1024px) 116px, 216px'
                  : '(max-width: 1024px) 116px, 290px'
            }
          />
        </div>
      )}
    </div>
  );
});

AppImage.displayName = 'AppImage';

export default AppImage;
